module.exports = __webpack_public_path__ + "static/media/mom.83c5efa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mom.jpg
// module id = 862
// module chunks = 0